<template>
  <b-card title="Tracking Page Link">
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-row class="align-items-center">
        <b-col
          cols="12"
          md="9"
        >
          <b-input-group>
            <b-input-group-prepend is-text>
              <feather-icon
                icon="LinkIcon"
                size="16"
              />
            </b-input-group-prepend>
            <b-form-input
              id="tracking-page-link"
              :value="displayLink"
              readonly
            />
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mt-1 mt-md-0"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="custom-button-color w-100"
            :disabled="!copyValue"
            @click="copyLink"
          >
            <feather-icon
              icon="CopyIcon"
              class="mr-25"
            />
            Copy Link
          </b-button>
        </b-col>
      </b-row>
      <p class="text-muted mt-1 mb-0">
        The waybill number is appended to this link when you share it with a customer.
      </p>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BOverlay, BRow, BCol, BFormInput, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import { trackingPageUrl, trackingEnv } from '@/constants/config'

const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  name: 'MyTracking',
  components: {
    BCard,
    BOverlay,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      loading: false,
      trackingPageLink: '',
    }
  },
  computed: {
    copyValue() {
      return this.formatTrackingHref(this.trackingPageLink)
    },
    displayLink() {
      return this.copyValue.replace(/^https?:\/\//, '')
    },
  },
  mounted() {
    this.fetchTrackingPage()
  },
  methods: {
    formatTrackingHref(link) {
      if (!link) {
        return ''
      }
      let href = String(link).trim()
      if (!href.startsWith('http')) {
        if (href.includes('.')) {
          href = `https://${href}`
        } else {
          const base = (trackingPageUrl || '').replace(/\/$/, '')
          href = `${base}${href.startsWith('/') ? href : `/${href}`}`
        }
      }
      const infix = trackingEnv || (window.location.host.includes('.int.curfox.com') ? 'int' : '')
      if (!infix || href.includes(`tracking.${infix}.curfox.com`)) {
        return href
      }
      return href.replace(/tracking\.curfox\.com(?=[/:?]|$)/, `tracking.${infix}.curfox.com`)
    },
    async fetchTrackingPage() {
      this.loading = true
      try {
        const { data } = await MerchantRepository.getTrackingPage()
        this.trackingPageLink = (data.data && data.data.tracking_page_link) || ''
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async copyLink() {
      if (!this.copyValue) {
        return
      }
      try {
        await navigator.clipboard.writeText(this.copyValue)
        this.showSuccessMessage('Link has been copied successfully!')
      } catch (e) {
        this.showErrorMessage('Failed to copy link')
      }
    },
  },
}
</script>
